import React from "react";
import { CardTitle, Card } from "reactstrap";
import classnames from "classnames";

import { SatisfactionScores } from "../../api";

export interface ScoresListData {
  company: string;
  scores: SatisfactionScores;
}

interface ScoresListProps {
  data: ScoresListData[];
  partnerName?: string,
}

const ScoresList: React.FC<ScoresListProps> = (props) => {
  return (
    <Card>
      <CardTitle
        tag="h5"
        className="mb-0 py-3 text-primary text-center text-uppercase fs-9 fw-6"
      >
        Scores
      </CardTitle>
      <div style={{ minHeight: "3rem" }}>
        {props.data.map((item, i) => (
          <div key={i} className={classnames({
            "px-3 py-2 border-top": true,
            "bg-panel-light text-primary": item.company && item.company === props.partnerName,
          })}>
            <div className="d-flex align-items-center">
              <div className="text-uppercase flex-grow-1 fw-6">{item.company}</div>
              <div className="fs-8 font-weight-bold ml-2">
                <span>{item.scores.overall}%</span>
              </div>
            </div>
            {(!!item.scores.content || !!item.scores.presenter) && (
              <div className="mt-2 d-flex justify-content-end no-line-spacing">
                {!!item.scores.content && (
                  <div className="ml-2 d-flex align-items-center">
                    <span className="fs-10">Content</span>
                    <span className="ml-1 fw-6">{item.scores.content}%</span>
                  </div>)}
                {!!item.scores.presenter && (
                  <div className="ml-2 d-flex align-items-center">
                    <span className="fs-10">Presenter</span>
                    <span className="ml-1 fw-6">{item.scores.presenter}%</span>
                  </div>)}
              </div>)}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ScoresList;
